<template>
  <v-select
    v-if="layout === 'select'"
    :value="value"
    :items="options"
    :disabled="disabled"
    item-text="label"
    item-value="value"
    :label="label"
    :light="light"
    :background-color="backgroundColor"
    dense
    outlined
    hide-details
    @change="$emit('input', $event)"
  >
    <template v-slot:selection="{ item }">
      <v-icon small left :color="item.color">{{ item.icon }}</v-icon>
      {{ item.label }}
    </template>
    <template v-slot:item="{ item }">
      <v-icon small left :color="item.color">{{ item.icon }}</v-icon>
      <span :title="item.hint">{{ item.label }}</span>
    </template>
  </v-select>

  <v-btn-toggle
    v-else
    :value="value"
    mandatory
    color="primary"
    class="aif-image-mode-toggle elevation-1"
    @change="$emit('input', $event)"
  >
    <label class="text-caption ma-2 grey--text text--darken-1">Image:</label>
    <v-btn
      v-for="mode in options"
      :key="mode.value"
      :value="mode.value"
      :disabled="disabled"
      :title="mode.hint"
      small
    >
      <v-icon small left>{{ mode.icon }}</v-icon>
      {{ mode.label }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import {
  AIF_IMAGE_MODES,
  AIF_SELECTABLE_IMAGE_MODES,
  AIF_SUPERADMIN_IMAGE_MODES,
} from "@/utils/aifImageModes";

// Choix du mode image d'un article AIF (image_handler), partage par tous les
// process manuels pour garder les memes libelles. v-model = valeur image_handler.
// layout "select" : version compacte pour les panneaux etroits (menu Options).
export default {
  name: "AifImageModeToggle",
  props: {
    value: {
      type: String,
      default: "generate",
    },
    modes: {
      type: Array,
      default: () => AIF_SELECTABLE_IMAGE_MODES,
    },
    layout: {
      type: String,
      default: "buttons",
      validator: (layout) => ["buttons", "select"].includes(layout),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Libelle du champ, layout "select" seulement. */
    label: {
      type: String,
      default: null,
    },
    /** Layout "select" sur fond sombre : champ clair, sinon l'icone primary
        de « Générer » se confond avec une barre primary. */
    light: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    isSuperadmin() {
      return this.$can("manage", "all");
    },
    options() {
      return this.modes
        .filter(
          (value) =>
            this.isSuperadmin || !AIF_SUPERADMIN_IMAGE_MODES.includes(value)
        )
        .map((value) => ({ value, ...AIF_IMAGE_MODES[value] }));
    },
  },
  watch: {
    // Un mode Shutterstock reste en store (choisi par un superadmin sur le meme
    // navigateur) ne doit pas partir a l'API pour un autre utilisateur, qui
    // recevrait un 403. Les autres valeurs (image_url, image_id) sont laissees.
    value: {
      immediate: true,
      handler(value) {
        if (!this.isSuperadmin && AIF_SUPERADMIN_IMAGE_MODES.includes(value)) {
          this.$emit("input", "generate");
        }
      },
    },
  },
};
</script>

<style scoped>
/* Colonne trop etroite : les boutons passent a la ligne dans le cadre au lieu
   d'en deborder (v-btn-toggle est un inline-flex sans retour a la ligne).
   align-self : dans un parent flex (v-col d-flex), ne pas s'etirer a sa hauteur. */
.aif-image-mode-toggle {
  max-width: 100%;
  flex-wrap: wrap;
  height: auto !important;
  align-self: flex-start;
}
</style>
